<template>

  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="primary--text">Acquistato il</th>
          <th class="primary--text">Costo</th>
          <th class="primary--text">Quantità</th>
          <th class="primary--text">Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr
          :key="index"
          v-for="(order, index) in article.orders"
        >
          <td>{{order.posix}}</td>
          <td>{{order.cost}}€</td>
          <td>{{order.amount}}</td>
          <td>
            <v-icon
              small
              class="mr-2"
              @click="$emit('edit-accessory', {item: article, index})"
            >
              mdi-pencil
            </v-icon>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
  export default {
    name: 'ArticleOrders',
    props: {
      article: { type: Object, default: () => { } },
    }
  }
</script>